import React, { FC } from "react";
import { FormControlLabel as MuiFormControlLabel } from "@mui/material";

type Props = React.ComponentProps<typeof MuiFormControlLabel>;

const FormControlLabel: FC<Props> = (props) => {
    return <MuiFormControlLabel {...props}/>
}

export default FormControlLabel;